(function () {
  var closeTimer = null;
  var rootMenuCloseTimer = null;
  var rootMenuFocusFrame = null;
  var rootMenuFocusTimer = null;
  var rootMenuScrollLock = null;
  var rootMenuTouchStartY = 0;
  var mobileMenuTransitionMs = 400;
  var focusableSelector =
    'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';

  function query(selector, root) {
    return (root || document).querySelector(selector);
  }

  function queryAll(selector, root) {
    return (root || document).querySelectorAll(selector);
  }

  function each(items, callback) {
    for (var index = 0; index < items.length; index += 1) {
      callback(items[index], index);
    }
  }

  function removeClass(items, className) {
    each(items, function (item) {
      item.classList.remove(className);
    });
  }

  function getFocusable(root) {
    if (!root) return [];

    return Array.prototype.slice
      .call(queryAll(focusableSelector, root))
      .filter(function (element) {
        return (
          !element.hasAttribute('disabled') &&
          !element.hidden &&
          element.getAttribute('aria-hidden') !== 'true' &&
          !element.closest('[aria-hidden="true"]') &&
          !element.closest('[hidden]') &&
          !element.closest('[inert]')
        );
      });
  }

  function focusElement(element) {
    if (!element) return;

    function moveFocus() {
      try {
        element.focus({ preventScroll: true });
      } catch (error) {
        element.focus();
      }
    }

    moveFocus();
    window.requestAnimationFrame(moveFocus);
    window.setTimeout(moveFocus, 60);
  }

  function focusFirst(root) {
    var focusable = getFocusable(root);

    if (focusable.length) {
      focusElement(focusable[0]);
    }
  }

  function getRootMenuInitialFocus(root) {
    if (!root) return null;

    return query('.menu-drawer-root-close, .close-menu', root);
  }

  function setDropdownState(active) {
    var menuDropdown = query('.menu-dropdown');
    var headerWrapper = query('.header-wrapper');

    if (menuDropdown) {
      menuDropdown.classList[active ? 'add' : 'remove']('dropdown-active');
    }

    if (headerWrapper) {
      headerWrapper.classList[active ? 'add' : 'remove']('show-overlay');
    }
  }

  function setDropdownHeight(menuItemDropDown) {
    var menuDropdown = query('.menu-dropdown');
    if (!menuDropdown || !menuItemDropDown) return;

    menuDropdown.style.height = menuItemDropDown.offsetHeight + 'px';
  }

  function clearDropdownTimer() {
    if (closeTimer) {
      window.clearTimeout(closeTimer);
      closeTimer = null;
    }
  }

  function setDesktopTriggerExpanded(menuItem, expanded) {
    var menuTrigger = query('.header__menu-item', menuItem);

    if (menuTrigger) {
      menuTrigger.setAttribute('aria-expanded', expanded ? 'true' : 'false');
    }
  }

  function closeDropdowns() {
    var menuDropdown = query('.menu-dropdown');

    clearDropdownTimer();
    removeClass(queryAll('.HorizontalList__Item'), 'active');
    removeClass(queryAll('.MegaMenu'), 'active');
    each(queryAll('.MegaMenu'), function (menuDropDown) {
      menuDropDown.setAttribute('aria-hidden', 'true');
    });
    each(queryAll('.HorizontalList__Item'), function (menuItem) {
      setDesktopTriggerExpanded(menuItem, false);
    });
    setDropdownState(false);

    if (menuDropdown) {
      menuDropdown.style.height = '0';
    }
  }

  function closeSingleDropdown(menuItem, menuItemDropDown) {
    var menuDropdown = query('.menu-dropdown');

    if (menuItem) {
      menuItem.classList.remove('active');
      setDesktopTriggerExpanded(menuItem, false);
    }

    if (menuItemDropDown) {
      menuItemDropDown.classList.remove('active');
      menuItemDropDown.setAttribute('aria-hidden', 'true');
    }

    if (!query('.MegaMenu.active')) {
      setDropdownState(false);

      if (menuDropdown) {
        menuDropdown.style.height = '0';
      }
    }
  }

  function scheduleCloseDropdowns() {
    clearDropdownTimer();
    closeTimer = window.setTimeout(closeDropdowns, 90);
  }

  function isMovingWithin(event, element) {
    return !!(event.relatedTarget && element.contains(event.relatedTarget));
  }

  function isFocusWithin(menuItem, menuItemDropDown) {
    return (
      menuItem.contains(document.activeElement) ||
      menuItemDropDown.contains(document.activeElement)
    );
  }

  function setDefaultSubmenuState(menuItem, expanded) {
    var trigger = query('.header__menu-item', menuItem);
    var menuDropdown = query('.menu-dropdown');

    if (expanded) {
      clearDropdownTimer();
      removeClass(queryAll('.MegaMenu'), 'active');
      each(queryAll('.MegaMenu'), function (menuDropDown) {
        menuDropDown.setAttribute('aria-hidden', 'true');
      });
      each(queryAll('.HorizontalList__Item'), function (item) {
        if (item !== menuItem) {
          item.classList.remove('active');
          setDesktopTriggerExpanded(item, false);
        }
      });
      setDropdownState(false);

      if (menuDropdown) {
        menuDropdown.style.height = '0';
      }
    }

    menuItem.classList[expanded ? 'add' : 'remove']('active');

    if (trigger) {
      trigger.setAttribute('aria-expanded', expanded ? 'true' : 'false');
    }
  }

  function getDirectSubmenu(container) {
    if (!container) return null;

    for (var index = 0; index < container.children.length; index += 1) {
      if (container.children[index].classList.contains('menu-drawer__submenu')) {
        return container.children[index];
      }
    }

    return null;
  }

  function getDirectMenuControl(container) {
    if (!container) return null;

    for (var index = 0; index < container.children.length; index += 1) {
      if (container.children[index].classList.contains('menu-drawer__menu-item')) {
        return container.children[index];
      }
    }

    return null;
  }

  function setInert(element, inert) {
    if (!element) return;

    element.setAttribute('aria-hidden', inert ? 'true' : 'false');

    if ('inert' in element) {
      element.inert = inert;
    }
  }

  function getMobileBackControl(submenu) {
    var submenuTop;
    var backControl;

    if (!submenu) return null;

    submenuTop =
      query('.menu-drawer__inner-submenu > .menudrawer-top', submenu) ||
      query('.menudrawer-top', submenu);
    backControl = submenuTop
      ? query('.menu-mobile-close-button, .menu-mobile-close-button-two', submenuTop)
      : null;

    return backControl;
  }

  function focusMobileSubmenu(submenu) {
    var backControl = getMobileBackControl(submenu);

    if (backControl) {
      focusElement(backControl);
      return;
    }

    focusFirst(submenu);
  }

  function setMobileControlSemantics(control, submenu) {
    if (!control || !submenu) return;

    if (!/^(A|BUTTON)$/i.test(control.tagName)) {
      control.setAttribute('role', 'button');
      control.setAttribute('tabindex', '0');
    }

    control.setAttribute('aria-haspopup', 'true');
    control.setAttribute('aria-expanded', 'false');

    if (submenu.id) {
      control.setAttribute('aria-controls', submenu.id);
    }
  }

  function setMobileSubmenuState(container, expanded, moveFocus) {
    var submenu = getDirectSubmenu(container);
    var control = getDirectMenuControl(container);

    if (!submenu || !control) return;

    container.classList[expanded ? 'add' : 'remove']('active');
    control.setAttribute('aria-expanded', expanded ? 'true' : 'false');
    setInert(submenu, !expanded);

    if (moveFocus) {
      if (expanded) {
        focusMobileSubmenu(submenu);
      } else {
        focusElement(control);
      }
    }
  }

  function getOpenMobileContainer() {
    var activeElement = document.activeElement;
    var focusedContainer =
      activeElement &&
      activeElement.closest('.menu-child-two.active, .menu-item-box.active');

    if (focusedContainer) {
      return focusedContainer;
    }

    var activeContainers = queryAll('.menu-child-two.active, .menu-item-box.active');

    return activeContainers.length
      ? activeContainers[activeContainers.length - 1]
      : null;
  }

  function activateKeyboardControl(event, callback) {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      callback();
    }
  }

  function getSectionHeader() {
    return query('#shopify-section-header') || query('.section-header');
  }

  function getRootMenuDrawerElements(control) {
    var details =
      (control && control.closest('#Details-menu-drawer-container')) ||
      query('#Details-menu-drawer-container');

    return {
      details: details,
      drawer: details ? query('#menu-drawer', details) : null,
      sectionHeader: getSectionHeader(),
      summary: details ? query('summary', details) : null,
    };
  }

  function clearRootMenuCloseTimer() {
    if (rootMenuCloseTimer) {
      window.clearTimeout(rootMenuCloseTimer);
      rootMenuCloseTimer = null;
    }
  }

  function clearRootMenuFocus() {
    if (rootMenuFocusFrame !== null) {
      window.cancelAnimationFrame(rootMenuFocusFrame);
      rootMenuFocusFrame = null;
    }
    if (rootMenuFocusTimer !== null) {
      window.clearTimeout(rootMenuFocusTimer);
      rootMenuFocusTimer = null;
    }
  }

  function scheduleRootMenuFocus(details, drawer, summary, retry) {
    var focusBeforeTask = document.activeElement;
    // Let the opening styles paint before focus asks the browser for layout.
    // One guarded task also prevents a close/reopen from focusing an old menu.
    rootMenuFocusFrame = window.requestAnimationFrame(function () {
      rootMenuFocusFrame = null;
      rootMenuFocusTimer = window.setTimeout(function () {
        rootMenuFocusTimer = null;
        if (
          !details.isConnected ||
          !details.hasAttribute('open') ||
          !details.classList.contains('menu-opening')
        ) {
          return;
        }

        var active = document.activeElement;
        if (
          getOpenMobileContainer() ||
          (active !== focusBeforeTask && active !== summary)
        ) {
          // Preserve a customer's intervening focus/submenu choice. Keep the
          // existing trap around that choice without returning to root focus.
          if (details.contains(active) && typeof window.trapFocus === 'function') {
            window.trapFocus(details, active);
          }
          return;
        }

        var target =
          getRootMenuInitialFocus(drawer || details) ||
          getFocusable(drawer || details)[0] ||
          drawer || summary || details;

        if (typeof window.trapFocus === 'function') {
          window.trapFocus(details, target);
        } else {
          try {
            target.focus({ preventScroll: true });
          } catch (error) {
            target.focus();
          }
        }
        // A reversed close transition can keep visibility hidden for this
        // frame. Retry once after the next paint only if focus did not stick.
        if (!retry && document.activeElement !== target) {
          scheduleRootMenuFocus(details, drawer, summary, true);
        }
      }, 0);
    });
  }

  function getRootMenuScrollTarget(target, drawer) {
    var element =
      target && target.nodeType === 1 ? target : target && target.parentElement;

    while (element && element !== drawer) {
      var style = window.getComputedStyle(element);
      var canScroll =
        /(auto|scroll|overlay)/.test(style.overflowY) &&
        element.scrollHeight > element.clientHeight + 1;

      if (canScroll) {
        return element;
      }

      element = element.parentElement;
    }

    return drawer;
  }

  function handleRootMenuTouchStart(event) {
    if (!rootMenuScrollLock || !event.touches || event.touches.length !== 1) {
      return;
    }

    rootMenuTouchStartY = event.touches[0].clientY;
  }

  function handleRootMenuTouchMove(event) {
    if (!rootMenuScrollLock || !event.touches || event.touches.length !== 1) {
      return;
    }

    var drawer = query('#menu-drawer');

    if (!drawer || !drawer.contains(event.target)) {
      event.preventDefault();
      return;
    }

    var currentY = event.touches[0].clientY;
    var deltaY = currentY - rootMenuTouchStartY;
    var scroller = getRootMenuScrollTarget(event.target, drawer);
    var atTop = scroller.scrollTop <= 0;
    var atBottom =
      scroller.scrollTop + scroller.clientHeight >= scroller.scrollHeight - 1;

    rootMenuTouchStartY = currentY;

    if ((deltaY > 0 && atTop) || (deltaY < 0 && atBottom)) {
      event.preventDefault();
    }
  }

  function addRootMenuTouchLock() {
    document.addEventListener('touchstart', handleRootMenuTouchStart, {
      capture: true,
      passive: true,
    });
    document.addEventListener('touchmove', handleRootMenuTouchMove, {
      capture: true,
      passive: false,
    });
  }

  function removeRootMenuTouchLock() {
    document.removeEventListener('touchstart', handleRootMenuTouchStart, true);
    document.removeEventListener('touchmove', handleRootMenuTouchMove, true);
  }

  function getRootMenuScrollY() {
    return (
      window.scrollY ||
      window.pageYOffset ||
      document.documentElement.scrollTop ||
      document.body.scrollTop ||
      0
    );
  }

  function lockRootMenuScroll(scrollY) {
    if (rootMenuScrollLock) return;

    var root = document.documentElement;
    var body = document.body;
    if (typeof scrollY !== 'number') scrollY = getRootMenuScrollY();

    rootMenuScrollLock = {
      scrollY: scrollY,
      rootOverflow: root.style.overflow,
      bodyOverflow: body.style.overflow,
      bodyPosition: body.style.position,
      bodyTop: body.style.top,
      bodyLeft: body.style.left,
      bodyRight: body.style.right,
      bodyWidth: body.style.width,
    };

    root.classList.add('legacy-menu-scroll-locked');
    root.style.overflow = 'hidden';
    body.style.overflow = 'hidden';
    body.style.position = 'fixed';
    body.style.top = '-' + scrollY + 'px';
    body.style.left = '0';
    body.style.right = '0';
    body.style.width = '100%';
    addRootMenuTouchLock();
  }

  function unlockRootMenuScroll() {
    if (!rootMenuScrollLock) return;

    var root = document.documentElement;
    var body = document.body;
    var scrollY = rootMenuScrollLock.scrollY;

    root.classList.remove('legacy-menu-scroll-locked');
    root.style.overflow = rootMenuScrollLock.rootOverflow;
    body.style.overflow = rootMenuScrollLock.bodyOverflow;
    body.style.position = rootMenuScrollLock.bodyPosition;
    body.style.top = rootMenuScrollLock.bodyTop;
    body.style.left = rootMenuScrollLock.bodyLeft;
    body.style.right = rootMenuScrollLock.bodyRight;
    body.style.width = rootMenuScrollLock.bodyWidth;
    rootMenuScrollLock = null;
    removeRootMenuTouchLock();

    window.scrollTo(0, scrollY);
  }

  function setRootMenuOpenState(open, options) {
    var elements = getRootMenuDrawerElements(options && options.control);
    var details = elements.details;
    var drawer = elements.drawer;
    var sectionHeader = elements.sectionHeader;
    var summary = elements.summary;
    var focusAfterClose = !(options && options.focusAfterClose === false);

    if (!details) return false;

    clearRootMenuCloseTimer();
    clearRootMenuFocus();

    if (open) {
      // Read before exposing the details subtree or changing root/body styles.
      var scrollY = rootMenuScrollLock ? rootMenuScrollLock.scrollY : getRootMenuScrollY();
      document.documentElement.classList.remove('mobile-drawer-closing');
      details.setAttribute('open', '');
      details.classList.add('menu-opening');
      details.classList.add('legacy-menu-opening');

      if (drawer) {
        drawer.classList.add('legacy-menu-visible');
        drawer.removeAttribute('aria-hidden');
      }

      if (sectionHeader) {
        sectionHeader.classList.add('menu-open');
        sectionHeader.classList.remove('shopify-section-header-hidden');
      }

      if (summary) {
        summary.setAttribute('aria-expanded', 'true');
      }

      document.documentElement.classList.add('legacy-menu-open');
      document.documentElement.classList.add('mobile-drawer-open');
      document.body.classList.add('overflow-hidden-tablet');
      lockRootMenuScroll(scrollY);
      scheduleRootMenuFocus(details, drawer, summary);

      return true;
    }

    details.classList.remove('menu-opening');
    details.classList.remove('legacy-menu-opening');
    document.documentElement.classList.add('mobile-drawer-closing');

    each(queryAll('.menu-item-box.active, .menu-child-two.active', details), function (item) {
      item.classList.remove('active');
    });

    if (drawer) {
      drawer.classList.remove('legacy-menu-visible');
      drawer.setAttribute('aria-hidden', 'true');
    }

    if (sectionHeader) {
      sectionHeader.classList.remove('menu-open');
    }

    if (summary) {
      summary.setAttribute('aria-expanded', 'false');
    }

    document.documentElement.classList.remove('legacy-menu-open');
    document.documentElement.classList.remove('mobile-drawer-open');
    document.body.classList.remove('overflow-hidden-tablet');
    document.body.classList.remove('overflow-hidden-mobile');

    if (typeof window.removeTrapFocus === 'function') {
      window.removeTrapFocus(focusAfterClose ? summary : null);
    }

    unlockRootMenuScroll();

    rootMenuCloseTimer = window.setTimeout(function () {
      if (!details.classList.contains('menu-opening')) {
        details.removeAttribute('open');
      }
      document.documentElement.classList.remove('mobile-drawer-closing');
    }, mobileMenuTransitionMs);

    return true;
  }

  function syncRootMenuDrawerState() {
    var elements = getRootMenuDrawerElements();
    var details = elements.details;
    var drawer = elements.drawer;
    var sectionHeader = elements.sectionHeader;
    var summary = elements.summary;
    var wantsOpen = !!(
      details &&
      details.hasAttribute('open') &&
      (!summary || summary.getAttribute('aria-expanded') !== 'false')
    );

    if (wantsOpen) {
      details.classList.add('menu-opening');
      document.documentElement.classList.remove('mobile-drawer-closing');
    }

    var isOpen = !!(
      details &&
      details.hasAttribute('open') &&
      details.classList.contains('menu-opening')
    );

    if (sectionHeader) {
      sectionHeader.classList[isOpen ? 'add' : 'remove']('menu-open');
    }

    if (drawer) {
      drawer.classList[isOpen ? 'add' : 'remove']('legacy-menu-visible');
      if (isOpen) {
        drawer.removeAttribute('aria-hidden');
      } else {
        drawer.setAttribute('aria-hidden', 'true');
      }
    }

    if (summary) {
      summary.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
    }

    document.documentElement.classList[isOpen ? 'add' : 'remove'](
      'legacy-menu-open'
    );
    document.documentElement.classList[isOpen ? 'add' : 'remove'](
      'mobile-drawer-open'
    );
    document.body.classList[isOpen ? 'add' : 'remove'](
      'overflow-hidden-tablet'
    );

    if (isOpen) {
      lockRootMenuScroll();
    } else {
      unlockRootMenuScroll();
    }

    if (!details || !details.hasAttribute('open')) {
      document.documentElement.classList.remove('mobile-drawer-closing');
    }
  }

  function scheduleRootMenuDrawerSync() {
    if (window.requestAnimationFrame) {
      window.requestAnimationFrame(syncRootMenuDrawerState);
    }
    window.setTimeout(syncRootMenuDrawerState, 0);
    window.setTimeout(syncRootMenuDrawerState, 80);
    window.setTimeout(syncRootMenuDrawerState, 200);
  }

  function closeRootMenuDrawer(control, focusAfterClose) {
    var details = getRootMenuDrawerElements(control).details;
    var wasOpen = details ? details.hasAttribute('open') : false;

    setRootMenuOpenState(false, {
      control: control,
      focusAfterClose: focusAfterClose !== false,
    });

    return wasOpen;
  }

  function initDesktopMenu() {
    var menuItems = queryAll(
      '.HorizontalList__Item:not(.HorizontalList_sub_menu)'
    );
    var menuItemsLink = queryAll(
      '.HorizontalList__Item.HorizontalList_sub_menu.menu_link'
    );
    var menuDropDowns = queryAll('.MegaMenu');
    var isTabletMenu = window.innerWidth < 1200 && window.innerWidth > 899;

    each(menuItems, function (menuItem) {
      var menuItemId = menuItem.getAttribute('id');
      var menuItemDropDown = menuItemId
        ? document.getElementById(menuItemId + '-megamenu')
        : null;
      var menuTrigger = query('.header__menu-item', menuItem);

      if (!menuItemDropDown || !menuTrigger) return;

      menuTrigger.setAttribute('aria-haspopup', 'true');
      menuTrigger.setAttribute('aria-expanded', 'false');
      menuTrigger.setAttribute('aria-controls', menuItemDropDown.id);

      function openDropdown() {
        clearDropdownTimer();
        removeClass(queryAll('.HorizontalList__Item'), 'active');
        removeClass(menuDropDowns, 'active');
        each(menuDropDowns, function (menuDropDown) {
          menuDropDown.setAttribute('aria-hidden', 'true');
        });
        each(queryAll('.HorizontalList__Item'), function (item) {
          setDesktopTriggerExpanded(item, false);
        });

        menuItem.classList.add('active');
        menuItemDropDown.classList.add('active');
        menuItemDropDown.setAttribute('aria-hidden', 'false');
        menuTrigger.setAttribute('aria-expanded', 'true');
        setDropdownState(true);
        setDropdownHeight(menuItemDropDown);
      }

      function closeIfLeaving(event) {
        if (
          isMovingWithin(event, menuItem) ||
          isMovingWithin(event, menuItemDropDown)
        ) {
          return;
        }

        scheduleCloseDropdowns();
      }

      function closeIfFocusLeaves() {
        window.setTimeout(function () {
          if (!isFocusWithin(menuItem, menuItemDropDown)) {
            closeSingleDropdown(menuItem, menuItemDropDown);
          }
        }, 0);
      }

      menuItem.addEventListener('mouseenter', openDropdown);
      menuItem.addEventListener('focusin', openDropdown);
      menuItem.addEventListener('mouseleave', closeIfLeaving);
      menuItem.addEventListener('focusout', closeIfFocusLeaves);
      menuItemDropDown.addEventListener('mouseenter', openDropdown);
      menuItemDropDown.addEventListener('focusin', clearDropdownTimer);
      menuItemDropDown.addEventListener('mouseleave', closeIfLeaving);
      menuItemDropDown.addEventListener('focusout', closeIfFocusLeaves);

      menuTrigger.addEventListener('keydown', function (event) {
        if (
          event.key === 'Enter' ||
          event.key === ' ' ||
          event.key === 'ArrowDown'
        ) {
          event.preventDefault();
          openDropdown();
          focusFirst(menuItemDropDown);
        }

        if (event.key === 'Escape') {
          event.preventDefault();
          closeDropdowns();
          menuTrigger.focus();
        }
      });

      menuItemDropDown.addEventListener('keydown', function (event) {
        if (event.key === 'Escape') {
          event.preventDefault();
          closeDropdowns();
          menuTrigger.focus();
        }
      });

      if (isTabletMenu) {
        menuItem.addEventListener('click', function (event) {
          var isActive = menuItem.classList.contains('active');

          event.preventDefault();

          if (isActive) {
            closeDropdowns();
          } else {
            openDropdown();
          }
        });
      }
    });

    each(menuItemsLink, function (menuLink) {
      var trigger = query('.header__menu-item', menuLink);
      var submenu = query('.sub_menu_default', menuLink);

      if (!trigger || !submenu) return;

      if (!submenu.id) {
        submenu.id = 'submenu-' + Math.random().toString(36).slice(2);
      }

      trigger.setAttribute('aria-haspopup', 'true');
      trigger.setAttribute('aria-expanded', 'false');
      trigger.setAttribute('aria-controls', submenu.id);

      menuLink.addEventListener('mouseenter', function () {
        setDefaultSubmenuState(menuLink, true);
      });
      menuLink.addEventListener('mouseleave', function () {
        setDefaultSubmenuState(menuLink, false);
      });
      menuLink.addEventListener('focusin', function () {
        setDefaultSubmenuState(menuLink, true);
      });
      menuLink.addEventListener('focusout', function () {
        window.setTimeout(function () {
          if (!menuLink.contains(document.activeElement)) {
            setDefaultSubmenuState(menuLink, false);
          }
        }, 0);
      });
      trigger.addEventListener('keydown', function (event) {
        if (
          event.key === 'Enter' ||
          event.key === ' ' ||
          event.key === 'ArrowDown'
        ) {
          event.preventDefault();
          setDefaultSubmenuState(menuLink, true);
          focusFirst(submenu);
        }

        if (event.key === 'Escape') {
          event.preventDefault();
          setDefaultSubmenuState(menuLink, false);
          trigger.focus();
        }
      });

      submenu.addEventListener('keydown', function (event) {
        if (event.key === 'Escape') {
          event.preventDefault();
          setDefaultSubmenuState(menuLink, false);
          trigger.focus();
        }
      });
    });

    if (isTabletMenu) {
      each(menuItemsLink, function (menuLink) {
        menuLink.addEventListener('click', function (event) {
          var isActive = menuLink.classList.contains('active');

          event.preventDefault();
          removeClass(queryAll('.HorizontalList__Item'), 'active');

          if (!isActive) {
            menuLink.classList.add('active');
          }
        });
      });
    }

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') {
        closeDropdowns();
      }
    });
  }

  function initMobileMenu() {
    var rootDetails = query('#Details-menu-drawer-container');
    var rootSummary = rootDetails ? query('summary', rootDetails) : null;
    var mobileMenu = query('.menu-mobile-custom');
    var menuItemMobiles = queryAll(
      '.menu-mobile-custom .menu-item-box > .menu-drawer__menu-item, .menu-mobile-custom .menu-child-two > .menu-drawer__menu-item'
    );
    var menuCloseButtons = queryAll('.menu-mobile-close-button');
    var menuCloseButtonsTwo = queryAll('.menu-mobile-close-button-two');
    var menuRootCloseButtons = queryAll('.menu-drawer-root-close');
    var menuRegionButtons = queryAll(
      '.menu-mobile .btn-region[data-geo-location-trigger]'
    );
    var menuBackButtons = Array.prototype.slice
      .call(menuCloseButtons)
      .concat(Array.prototype.slice.call(menuCloseButtonsTwo));

    if (rootSummary) {
      rootSummary.addEventListener(
        'click',
        function (event) {
          var details = rootSummary.closest('#Details-menu-drawer-container');
          var isOpen = !!(
            details &&
            details.hasAttribute('open') &&
            details.classList.contains('menu-opening')
          );

          event.preventDefault();
          event.stopImmediatePropagation();

          setRootMenuOpenState(!isOpen, { control: rootSummary });
        },
        true
      );
    }

    if (rootDetails) {
      rootDetails.addEventListener('toggle', scheduleRootMenuDrawerSync);
      rootDetails.addEventListener(
        'keyup',
        function (event) {
          if (
            event.key !== 'Escape' ||
            !rootDetails.classList.contains('menu-opening') ||
            getOpenMobileContainer()
          ) {
            return;
          }

          // The standalone handler owns opening; close through the same path
          // so scroll/focus cleanup does not fall through to HeaderDrawer.
          event.preventDefault();
          event.stopImmediatePropagation();
          closeRootMenuDrawer(rootSummary);
        },
        true
      );
    }

    each(menuItemMobiles, function (menuItemMobile) {
      var container = menuItemMobile.parentElement;
      var submenu = getDirectSubmenu(container);

      if (!submenu) return;

      submenu.classList.remove('hidden');
      setMobileControlSemantics(menuItemMobile, submenu);
      setInert(submenu, true);

      menuItemMobile.addEventListener('click', function () {
        setMobileSubmenuState(
          container,
          !container.classList.contains('active'),
          true
        );
      });

      menuItemMobile.addEventListener('keydown', function (event) {
        activateKeyboardControl(event, function () {
          setMobileSubmenuState(container, true, true);
        });

        if (event.key === 'ArrowRight') {
          event.preventDefault();
          setMobileSubmenuState(container, true, true);
        }
      });
    });

    each(menuBackButtons, function (menuBackButton) {
      if (!/^(A|BUTTON)$/i.test(menuBackButton.tagName)) {
        menuBackButton.setAttribute('role', 'button');
        menuBackButton.setAttribute('tabindex', '0');
      }

      function closeSubmenu() {
        var container = menuBackButton.closest('.menu-child-two, .menu-item-box');

        if (container) {
          setMobileSubmenuState(container, false, true);
        }
      }

      menuBackButton.addEventListener('click', closeSubmenu);
      menuBackButton.addEventListener('keydown', function (event) {
        activateKeyboardControl(event, closeSubmenu);

        if (event.key === 'ArrowLeft') {
          event.preventDefault();
          closeSubmenu();
        }
      });
    });

    each(menuRootCloseButtons, function (menuRootCloseButton) {
      menuRootCloseButton.addEventListener(
        'click',
        function (event) {
          event.preventDefault();
          event.stopImmediatePropagation();
          closeRootMenuDrawer(menuRootCloseButton);
        },
        true
      );
    });

    each(menuRegionButtons, function (menuRegionButton) {
      menuRegionButton.addEventListener(
        'click',
        function (event) {
          var wasOpen;

          event.preventDefault();
          event.stopImmediatePropagation();

          wasOpen = closeRootMenuDrawer(menuRegionButton, false);
          window.setTimeout(
            function () {
              document.dispatchEvent(new CustomEvent('geo-location-trigger'));
            },
            wasOpen ? mobileMenuTransitionMs : 0
          );
        },
        true
      );
    });

    if (mobileMenu) {
      mobileMenu.addEventListener(
        'keyup',
        function (event) {
          var openContainer;

          if (event.key !== 'Escape') return;

          openContainer = getOpenMobileContainer();

          if (openContainer) {
            event.preventDefault();
            event.stopImmediatePropagation();
            setMobileSubmenuState(openContainer, false, true);
          }
        },
        true
      );
    }
  }

  initDesktopMenu();
  initMobileMenu();
})();
